import { useRef, useState } from "react";

import { IconButton } from "@atlaskit/button-next/new";
import { FeedbackFlag } from "@atlaskit/feedback-collector";
import { FormFields } from "@atlaskit/feedback-collector";
import { FlagGroup } from "@atlaskit/flag";
import MegaphoneIcon from "@atlaskit/icon/core/megaphone";
import { Box } from "@atlaskit/primitives-next";

import { FeedbackCollectorModal } from "./feedback-collector-modal";
import { useFeedbackCollectorAnalytics } from "./hooks";

export const FeedbackCollector = () => {
    const ref = useRef<HTMLButtonElement | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [displayFlag, setDisplayFlag] = useState(false);

    const hideFlag = () => setDisplayFlag(false);
    const showFlag = () => setDisplayFlag(true);

    const {
        sendFeedbackCollectorOpenButtonClickUIEvent,
        sendFeedbackCollectorSubmitButtonClickUIEvent
    } = useFeedbackCollectorAnalytics();

    const handleOpen = () => {
        setIsOpen(true);
        sendFeedbackCollectorOpenButtonClickUIEvent();
    };

    const handleSubmit = (formFields: FormFields) => {
        setIsOpen(false);
        showFlag();
        sendFeedbackCollectorSubmitButtonClickUIEvent(formFields.type);
    };

    const handleClose = () => setIsOpen(false);

    return (
        <Box
            id="fastshift-feedback-collector"
            testId="fastshift-feedback-collector"
        >
            <IconButton
                appearance="subtle"
                label="open customer feedback collector"
                onClick={handleOpen}
                icon={MegaphoneIcon}
                ref={ref}
            />

            {isOpen && (
                <FeedbackCollectorModal
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    shouldReturnFocusRef={ref}
                />
            )}

            <FlagGroup onDismissed={hideFlag}>
                {displayFlag && <FeedbackFlag />}
            </FlagGroup>
        </Box>
    );
};
